import { ReportData } from '@/pages/DemandReports/Header/ReportDialog'
import { apiAtlas } from '@/services/api/apiAtlas'

export async function createReport(demandId: string, reportData: ReportData) {
  return apiAtlas.post(
    `/weed/cane/${demandId}/reports`,
    reportData
  )
}